<div class="input-group input-group-sm">
    <input type="number" class="form-control" [disabled]="disabled"
           [(ngModel)]="displayValue" (ngModelChange)="setValue($event)" placement="top"
           ngbTooltip="Edit {{field}}">
</div>
